import $ from "jquery";
import debug from "bows";
const log = debug("ajaxForm");

export function ajaxForm(opts) {
	const { $form, $list, action, loadMoreSelector = 'button', callbacks } = opts;
	let paged = 1;

	log('Watching...', $form, $list);

	const submit = (e) => {
		e.preventDefault();
		if ( isLocked() ) {
			return;
		}

		if ( callbacks['submit'] && typeof callbacks['submit'] === 'function' ) {
			callbacks['submit']();
		}

		// Reset page number
		paged = 1;

		// Ajax request with replace
		ajax(replace);
	}

	const loadMore = (e) => {
		if ( isLocked() ) {
			return;
		}

		if ( callbacks['loadMore'] && typeof callbacks['loadMore'] === 'function' ) {
			callbacks['loadMore']();
		}

		// Update page number
		paged = $list.find(loadMoreSelector).data('paged');

		// Ajax request with append
		ajax(append);
	}

	const ajax = (done) => {
		lock();

		// AJAX call
		$.ajax({
			dataType: 'json',
			url: action,
			data: $form.serialize() + '&paged=' + paged,
		}).done(function ( response ) {
			if ( response && response.success ) {
				if ( callbacks['done'] && typeof callbacks['done'] === 'function' ) {
					callbacks['done'](response);
				}
				done(response.data);
			}
		}).fail(function () {
			if ( callbacks['fail'] && typeof callbacks['fail'] === 'function' ) {
				callbacks['fail']();
			}
			alert('Please try again!');
		}).always(function () {
			unlock();
		});
	}

	const isLocked = () => {
		return $form.data('locked');
	}

	const lock = () => {
		$form.data('locked', true);
		$form.css('opacity', 0.5);
		$list.find(loadMoreSelector).css('opacity', 0.5);
	}

	const unlock = () => {
		$form.css('opacity', 1);
		$form.data('locked', null);
		$list.find(loadMoreSelector).css('opacity', null);
	}

	const replace = (html) => {
		$list.empty().append(html);
		if ( callbacks['replace'] && typeof callbacks['replace'] === 'function' ) {
			callbacks['replace']();
		}
	}

	const append = (html) => {
		$list.find(loadMoreSelector).remove();
		$list.append(html);
		if ( callbacks['append'] && typeof callbacks['append'] === 'function' ) {
			callbacks['append']();
		}
	}

	// Attach submit event
	$form.on('submit', (e) => submit(e));

	// Attach delegated load more event
	$list.on('click', loadMoreSelector, (e) => loadMore(e));
}

// Public
window.ajaxForm = ajaxForm;

export default {
	ajaxForm
};
